import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { Select, selectCustomStyles } from '../../../../../primitives/Select/index.js';
export const SortingDropdown = ({
  value,
  options,
  onChange
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  const mdUp = useBreakpointUp('md');
  return _jsx(Select, {
    fullWidth: true,
    options: options,
    value: options.find(option => option.value === value),
    isSearchable: false,
    menuShouldScrollIntoView: false,
    highlightBehaviour: "always",
    formatSingleValue: state => ({
      prefix: mdUp ? t('amadeusRatingSection.sorting.prefix') : '',
      value: state.data.label
    }),
    styles: {
      menu: (...args) => ({
        ...selectCustomStyles.menu(...args),
        right: mdUp ? 'auto' : '0',
        width: mdUp ? '100%' : '150%'
      })
    },
    onChange: ({
      value
    }) => {
      onChange(value);
    }
  });
};